import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import FeedbackModal from "./FeedbackModal";

/** `plg`: opened from the PLG app (/hire/feedback), so the forms send as the PLG customer. */
function FeedbackScreen({ plg = false }) {
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Edge | Feedback</title>
      </Helmet>
      <div>
        <FeedbackModal open={isModalOpen} onClose={handleModalClose} plg={plg} />
      </div>
    </>
  );
}

export default FeedbackScreen;
